export default __webpack_public_path__ + "static/media/arrowNextDisabled.767a87d5.svg";